import React, { Component } from 'react'
import PropTypes from 'prop-types'
import StateCounts from './StateCounts'
import DomainCounts from './DomainCounts'
import StateCountsGrid from './StateCountsGrid'
import ViolationOverview from './ViolationOverview'
import './Statistics.css'

class Statistics extends Component {
	constructor(props) {
		super(props)
		
		const urlParams = new URLSearchParams(window.location.search)
		const tabParam = urlParams.get('tab')
		const validTabs = [
			'state-counts',
			'state-counts-grid',
			'violation-overview',
			'domain-counts',
		]
		const hasDomainParam = urlParams.has('domain')

		let initialTab = 'state-counts'
		if (tabParam && validTabs.includes(tabParam)) {
			initialTab = tabParam
		} else if (hasDomainParam) {
			initialTab = 'domain-counts'
		}

		this.state = {
			activeTab: initialTab,
		}
	}

	handleTabChange = (tab) => {
		this.setState({ activeTab: tab })
	}

	render() {
		const { activeTab } = this.state

		return (
			<div className="statistics-container">
				<div className="statistics-header">
					<h1 className="statistics-title">Statistics</h1>
					<p className="statistics-subtitle">View violation statistics across clients</p>
				</div>

			<div className="statistics-tabs">
				<button
					className={`tab-button ${activeTab === 'state-counts' ? 'active' : ''}`}
					onClick={() => this.handleTabChange('state-counts')}
				>
					State Counts
				</button>
				<button
					className={`tab-button ${activeTab === 'state-counts-grid' ? 'active' : ''}`}
					onClick={() => this.handleTabChange('state-counts-grid')}
				>
					Operation overview
				</button>
				<button
					className={`tab-button ${activeTab === 'violation-overview' ? 'active' : ''}`}
					onClick={() => this.handleTabChange('violation-overview')}
				>
					Violation overview
				</button>
				<button
					className={`tab-button ${activeTab === 'domain-counts' ? 'active' : ''}`}
					onClick={() => this.handleTabChange('domain-counts')}
				>
					Domain Counts
				</button>
			</div>			<div className="tab-content">
				{activeTab === 'state-counts' && <StateCounts />}
				{activeTab === 'state-counts-grid' && <StateCountsGrid />}
				{activeTab === 'violation-overview' && <ViolationOverview />}
				{activeTab === 'domain-counts' && <DomainCounts />}
			</div>
			</div>
		)
	}
}

Statistics.contextTypes = {
	gettext: PropTypes.func.isRequired,
}

export default Statistics


